export const pdcTypeOptions = [
  { id: -1, name: "All" },
  { id: 1, name: "PDC" },
  { id: 0, name: "Non-PDC" }
];

export const paymentStatusOptions = [
  { id: "All", name: "All" },
  { id: "Paid", name: "Paid" },
  { id: "Not Paid", name: "Not Paid" }
];
